/** Must match `apps/mail/app/lib/open-mailbox-intent.ts`. */
export const WEBMAIL_OPEN_ACCOUNT_KEY = "bafe_webmail_open_account";

export function webmailBaseUrl(): string {
	const configured = import.meta.env.VITE_WEBMAIL_URL?.trim().replace(/\/$/, "");
	if (configured) return configured;
	return `${window.location.origin}/mail`;
}

/** Default combined mail entry — separate Mail SPA at `/mail/{slug}`. */
export function webmailInboxUrl(workspaceSlug?: string): string {
	if (workspaceSlug) {
		return `${webmailBaseUrl()}/${encodeURIComponent(workspaceSlug)}`;
	}
	return `${webmailBaseUrl()}/`;
}

/** Uses the Bafe mailbox id — Stalwart account ids may contain `/` and break path routing. */
export function webmailMailboxInboxUrl(mailboxId: string, workspaceSlug?: string): string {
	if (workspaceSlug) {
		return `${webmailBaseUrl()}/${encodeURIComponent(workspaceSlug)}/${encodeURIComponent(mailboxId)}/inbox?standalone=1`;
	}
	return `${webmailBaseUrl()}/${encodeURIComponent(mailboxId)}/inbox?standalone=1`;
}

const MAIL_MANAGE_FIRST_SEGMENTS = new Set(["mailboxes", "aliases", "forwarders", "migration"]);

/** Customer webmail at `/mail/{slug}` — not Manage email settings under `/mail/mailboxes`. */
export function isCustomerWebmailPath(pathname: string): boolean {
	if (pathname === "/mail") return true;
	if (!pathname.startsWith("/mail/")) return false;
	const segment = pathname.slice("/mail/".length).split("/")[0] ?? "";
	return !MAIL_MANAGE_FIRST_SEGMENTS.has(segment);
}

/** New webmail tabs do not share sessionStorage; localStorage carries the intended mailbox briefly. */
export function rememberWebmailOpenAccount(mailboxId: string): void {
	try {
		localStorage.setItem(WEBMAIL_OPEN_ACCOUNT_KEY, mailboxId);
	} catch {
		// Private mode or blocked storage — URL alone must work.
	}
}
